import { createContext } from 'react';

/** Optional containing viewport for isolated embedded product experiences. */
export const LearnViewportContext = createContext<HTMLElement | null>(null);
